// TODO: Migrate My Plans to Microapp

import {Component, OnInit, Input} from '@angular/core';
import {ShopDataService} from '@webu/data';
import {BasicConnectivity} from '@ox/typings';
import {Subject, takeUntil} from 'rxjs';
import {AutoDestroy} from '@ox/utils';

@Component({
  selector: 'webu-included-plan',
  templateUrl: './included-plan.component.html'
})
export class IncludedPlanComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() plan: BasicConnectivity;
  @Input() vehicleMake: string;
  @Input() canOpenPlanModal = false;

  includedPlanAndDate: string;

  constructor(
    private shopDataService: ShopDataService
  ) {}

  ngOnInit(): void {
    this.shopDataService.getCopyData().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.includedPlanAndDate = this.getGenericCopy('myplans.basic.connectivity.copy', {
        planName: this.plan.planId ?? 'Your plan',
        planDate: this.plan?.connectivityPlans[0]?.planDatesText ?? ''
      })?.split(this.plan.planId)[1] ?? '';
    });
  }

  getGenericCopy(id: string, variableMap: Record<string, string> = {}) {
    return this.shopDataService.getGenericCopy(id, variableMap);
  }
  getPlanCopy(planCode: string) {
    return this.shopDataService.getProductCopyByCode(planCode, {Brand: this.vehicleMake});
  }

}
